module.exports = __webpack_public_path__ + "img/overlay.dd30aa7e.png";